module.exports = __webpack_public_path__ + "first-5-hologram.jpg?b1ee18439065727f717abed92f77566f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-5-hologram.jpg
// module id = 513
// module chunks = 0